import React from "react";
import { Typography, Box } from "@mui/material";
import SimplePaper from "../../../components/SimplePaper";
import { MathComponent } from "mathjax-react";

const D12fromD1 = () => {
  const title = "Calculation of D12 (Dwadasamsa) from D1 (Rasi)";

  const body = (
    <>
      <Typography variant="body1" paragraph>
        The D12 chart, or Dwadasamsa chart, is used in Vedic astrology to
        analyze family legacy, ancestral inheritance, and karmic influences.
        Below is the step-by-step process to calculate the D12 chart from the D1
        (Rasi) chart.
      </Typography>

      <Typography variant="h4" gutterBottom>
        Procedure to Calculate D12 (Dwadasamsa) from D1 (Rasi)
      </Typography>

      <Typography variant="h5" gutterBottom>
        1. Identify the Planet's Degree in the D1 Chart
      </Typography>

      <Typography variant="body1" paragraph>
        First, identify the degree of the planet in the D1 chart. For example,
        if Venus is located at 13° Taurus, this degree will be used for the
        calculation.
      </Typography>

      <Typography variant="h5" gutterBottom>
        2. Divide the Sign into Twelve Parts
      </Typography>

      <Typography variant="body1" paragraph>
        Each zodiac sign is divided into twelve equal parts, each spanning 2.5°.
        To find the Dwadasamsa position of a planet, we divide its degree in the
        sign by 2.5.
      </Typography>

      <Box sx={{ textAlign: "center", margin: "1rem 0" }}>
        <MathComponent
          tex={String.raw`Dwadasamsa \ Position = \frac{Degree \ in \ Sign}{2.5}`}
        />
      </Box>

      <Typography variant="body1" paragraph>
        Depending on the result, we can determine the section in which the
        planet lies:
      </Typography>

      <Box sx={{ textAlign: "left", margin: "1rem 0" }}>
        <Typography variant="body1" component="span">
          - If{" "}
        </Typography>
        <MathComponent
          tex={String.raw`0 \leq \frac{Degree \ in \ Sign}{2.5} < 1`}
          display={false}
        />
        <Typography variant="body1" component="span">
          , the planet is in the <strong>first 2.5°</strong>.
        </Typography>
      </Box>

      <Box sx={{ textAlign: "left", margin: "1rem 0" }}>
        <Typography variant="body1" component="span">
          - If{" "}
        </Typography>
        <MathComponent
          tex={String.raw`1 \leq \frac{Degree \ in \ Sign}{2.5} < 2`}
          display={false}
        />
        <Typography variant="body1" component="span">
          , the planet is in the <strong>second 2.5°</strong>.
        </Typography>
      </Box>

      <Box sx={{ textAlign: "left", margin: "1rem 0" }}>
        <Typography variant="body1" component="span">
          - If{" "}
        </Typography>
        <MathComponent
          tex={String.raw`2 \leq \frac{Degree \ in \ Sign}{2.5} < 3`}
          display={false}
        />
        <Typography variant="body1" component="span">
          , the planet is in the <strong>third 2.5°</strong>.
        </Typography>
      </Box>

      <Box sx={{ textAlign: "left", margin: "1rem 0" }}>
        <Typography variant="body1" component="span">
          - If{" "}
        </Typography>
        <MathComponent
          tex={String.raw`3 \leq \frac{Degree \ in \ Sign}{2.5} < 4`}
          display={false}
        />
        <Typography variant="body1" component="span">
          , the planet is in the <strong>fourth 2.5°</strong>.
        </Typography>
      </Box>

      <Box sx={{ textAlign: "left", margin: "1rem 0" }}>
        <Typography variant="body1" component="span">
          - If{" "}
        </Typography>
        <MathComponent
          tex={String.raw`4 \leq \frac{Degree \ in \ Sign}{2.5} < 5`}
          display={false}
        />
        <Typography variant="body1" component="span">
          , the planet is in the <strong>fifth 2.5°</strong>.
        </Typography>
      </Box>

      <Box sx={{ textAlign: "left", margin: "1rem 0" }}>
        <Typography variant="body1" component="span">
          - If{" "}
        </Typography>
        <MathComponent
          tex={String.raw`5 \leq \frac{Degree \ in \ Sign}{2.5} < 6`}
          display={false}
        />
        <Typography variant="body1" component="span">
          , the planet is in the <strong>sixth 2.5°</strong>.
        </Typography>
      </Box>

      <Box sx={{ textAlign: "left", margin: "1rem 0" }}>
        <Typography variant="body1" component="span">
          - If{" "}
        </Typography>
        <MathComponent
          tex={String.raw`6 \leq \frac{Degree \ in \ Sign}{2.5} < 7`}
          display={false}
        />
        <Typography variant="body1" component="span">
          , the planet is in the <strong>seventh 2.5°</strong>.
        </Typography>
      </Box>

      <Box sx={{ textAlign: "left", margin: "1rem 0" }}>
        <Typography variant="body1" component="span">
          - If{" "}
        </Typography>
        <MathComponent
          tex={String.raw`7 \leq \frac{Degree \ in \ Sign}{2.5} < 8`}
          display={false}
        />
        <Typography variant="body1" component="span">
          , the planet is in the <strong>eighth 2.5°</strong>.
        </Typography>
      </Box>

      <Box sx={{ textAlign: "left", margin: "1rem 0" }}>
        <Typography variant="body1" component="span">
          - If{" "}
        </Typography>
        <MathComponent
          tex={String.raw`8 \leq \frac{Degree \ in \ Sign}{2.5} < 9`}
          display={false}
        />
        <Typography variant="body1" component="span">
          , the planet is in the <strong>ninth 2.5°</strong>.
        </Typography>
      </Box>

      <Box sx={{ textAlign: "left", margin: "1rem 0" }}>
        <Typography variant="body1" component="span">
          - If{" "}
        </Typography>
        <MathComponent
          tex={String.raw`9 \leq \frac{Degree \ in \ Sign}{2.5} < 10`}
          display={false}
        />
        <Typography variant="body1" component="span">
          , the planet is in the <strong>tenth 2.5°</strong>.
        </Typography>
      </Box>

      <Box sx={{ textAlign: "left", margin: "1rem 0" }}>
        <Typography variant="body1" component="span">
          - If{" "}
        </Typography>
        <MathComponent
          tex={String.raw`10 \leq \frac{Degree \ in \ Sign}{2.5} < 11`}
          display={false}
        />
        <Typography variant="body1" component="span">
          , the planet is in the <strong>eleventh 2.5°</strong>.
        </Typography>
      </Box>

      <Box sx={{ textAlign: "left", margin: "1rem 0" }}>
        <Typography variant="body1" component="span">
          - If{" "}
        </Typography>
        <MathComponent
          tex={String.raw`11 \leq \frac{Degree \ in \ Sign}{2.5} < 12`}
          display={false}
        />
        <Typography variant="body1" component="span">
          , the planet is in the <strong>twelfth 2.5°</strong>.
        </Typography>
      </Box>

      <Typography variant="h5" gutterBottom>
        3. Assign the Dwadasamsa Based on the Planet's Degree
      </Typography>

      <Typography variant="body1" paragraph>
        <strong>First 2.5°:</strong> The planet is assigned to the{" "}
        <strong>same sign</strong> as the D1 sign.
      </Typography>
      <Typography variant="body1" paragraph>
        <strong>Second 2.5°:</strong> The planet is assigned to the{" "}
        <strong>2nd sign</strong> from the D1 sign.
      </Typography>
      <Typography variant="body1" paragraph>
        <strong>Third 2.5°:</strong> The planet is assigned to the{" "}
        <strong>3rd sign</strong> from the D1 sign.
      </Typography>
      <Typography variant="body1" paragraph>
        <strong>Fourth 2.5°:</strong> The planet is assigned to the{" "}
        <strong>4th sign</strong> from the D1 sign.
      </Typography>
      <Typography variant="body1" paragraph>
        <strong>Fifth 2.5°:</strong> The planet is assigned to the{" "}
        <strong>5th sign</strong> from the D1 sign.
      </Typography>
      <Typography variant="body1" paragraph>
        <strong>Sixth 2.5°:</strong> The planet is assigned to the{" "}
        <strong>6th sign</strong> from the D1 sign.
      </Typography>
      <Typography variant="body1" paragraph>
        <strong>Seventh 2.5°:</strong> The planet is assigned to the{" "}
        <strong>7th sign</strong> from the D1 sign.
      </Typography>
      <Typography variant="body1" paragraph>
        <strong>Eighth 2.5°:</strong> The planet is assigned to the{" "}
        <strong>8th sign</strong> from the D1 sign.
      </Typography>
      <Typography variant="body1" paragraph>
        <strong>Ninth 2.5°:</strong> The planet is assigned to the{" "}
        <strong>9th sign</strong> from the D1 sign.
      </Typography>
      <Typography variant="body1" paragraph>
        <strong>Tenth 2.5°:</strong> The planet is assigned to the{" "}
        <strong>10th sign</strong> from the D1 sign.
      </Typography>
      <Typography variant="body1" paragraph>
        <strong>Eleventh 2.5°:</strong> The planet is assigned to the{" "}
        <strong>11th sign</strong> from the D1 sign.
      </Typography>
      <Typography variant="body1" paragraph>
        <strong>Twelfth 2.5°:</strong> The planet is assigned to the{" "}
        <strong>12th sign</strong> from the D1 sign.
      </Typography>

      <Typography variant="h4" gutterBottom>
        Example: Calculating Venus at 13° Taurus
      </Typography>

      <Typography variant="body1" paragraph>
        Taurus is the D1 sign. Venus at 13° falls in the sixth 2.5° (between
        12.5° and 15°). Therefore, it belongs to the <strong>6th sign</strong>{" "}
        from Taurus, which is <strong>Libra</strong>
      </Typography>

      <Typography variant="h4" gutterBottom>
        Python Program to Calculate D12 (Dwadasamsa) from D1
      </Typography>

      <Typography variant="body1" paragraph>
        Below is a Python program that performs the calculation of the D12
        (Dwadasamsa) position from the D1 (Rasi) chart, using the planet's
        degree and sign in the D1 chart.
      </Typography>

      <Box
        component="pre"
        sx={{
          padding: "1rem",
          backgroundColor: "#f5f5f5",
          borderRadius: "5px",
        }}
      >
        <code>
          {`def calculate_dwadasamsa(degree, sign):
    # List of zodiac signs in order
    zodiac_signs = ['Aries', 'Taurus', 'Gemini', 'Cancer', 'Leo', 'Virgo', 'Libra', 'Scorpio', 'Sagittarius', 'Capricorn', 'Aquarius', 'Pisces']

    # Get the index of the current sign in the zodiac cycle
    sign_index = zodiac_signs.index(sign)

    # Determine which Dwadasamsa the planet is in based on its degree
    if degree <= 2.5:
        # First 2.5° belongs to the same sign
        dwadasamsa_sign = zodiac_signs[sign_index]
    elif 2.5 < degree <= 5:
        # Second 2.5° belongs to the 2nd sign from the current sign
        dwadasamsa_sign = zodiac_signs[(sign_index + 1) % 12]
    elif 5 < degree <= 7.5:
        # Third 2.5° belongs to the 3rd sign from the current sign
        dwadasamsa_sign = zodiac_signs[(sign_index + 2) % 12]
    elif 7.5 < degree <= 10:
        # Fourth 2.5° belongs to the 4th sign from the current sign
        dwadasamsa_sign = zodiac_signs[(sign_index + 3) % 12]
    elif 10 < degree <= 12.5:
        # Fifth 2.5° belongs to the 5th sign from the current sign
        dwadasamsa_sign = zodiac_signs[(sign_index + 4) % 12]
    elif 12.5 < degree <= 15:
        # Sixth 2.5° belongs to the 6th sign from the current sign
        dwadasamsa_sign = zodiac_signs[(sign_index + 5) % 12]
    elif 15 < degree <= 17.5:
        # Seventh 2.5° belongs to the 7th sign from the current sign
        dwadasamsa_sign = zodiac_signs[(sign_index + 6) % 12]
    elif 17.5 < degree <= 20:
        # Eighth 2.5° belongs to the 8th sign from the current sign
        dwadasamsa_sign = zodiac_signs[(sign_index + 7) % 12]
    elif 20 < degree <= 22.5:
        # Ninth 2.5° belongs to the 9th sign from the current sign
        dwadasamsa_sign = zodiac_signs[(sign_index + 8) % 12]
    elif 22.5 < degree <= 25:
        # Tenth 2.5° belongs to the 10th sign from the current sign
        dwadasamsa_sign = zodiac_signs[(sign_index + 9) % 12]
    elif 25 < degree <= 27.5:
        # Eleventh 2.5° belongs to the 11th sign from the current sign
        dwadasamsa_sign = zodiac_signs[(sign_index + 10) % 12]
    else:
        # Twelfth 2.5° belongs to the 12th sign from the current sign
        dwadasamsa_sign = zodiac_signs[(sign_index + 11) % 12]

    return dwadasamsa_sign

# Example usage
planet = "Venus"
degree = 13
sign = "Taurus"

dwadasamsa_sign = calculate_dwadasamsa(degree, sign)
print(f"{planet} at {degree}° {sign} in the D1 chart is placed in {dwadasamsa_sign} in the D12 chart.")`}
        </code>
      </Box>

      <Typography variant="body1" paragraph>
        The above Python program calculates the Dwadasamsa for a planet based on
        its degree and sign in the D1 chart. The program divides the sign into
        twelve equal parts and assigns the Dwadasamsa based on the planet's
        degree.
      </Typography>

      <Typography variant="h4" gutterBottom>
        Explanation of the Formula Used in the Python Program
      </Typography>

      <Typography variant="body1" paragraph>
        The program divides the sign into twelve parts: the first 2.5°, the
        second 2.5°, and so on. It assigns the Dwadasamsa based on the planet's
        degree within the sign:
        <br />
        - First 2.5° belongs to the same sign.
        <br />
        - Second 2.5° belongs to the 2nd sign from the D1 sign.
        <br />
        - Third 2.5° belongs to the 3rd sign from the D1 sign.
        <br />
        - Fourth 2.5° belongs to the 4th sign from the D1 sign.
        <br />
        - Fifth 2.5° belongs to the 5th sign from the D1 sign.
        <br />
        - Sixth 2.5° belongs to the 6th sign from the D1 sign.
        <br />
        - Seventh 2.5° belongs to the 7th sign from the D1 sign.
        <br />
        - Eighth 2.5° belongs to the 8th sign from the D1 sign.
        <br />
        - Ninth 2.5° belongs to the 9th sign from the D1 sign.
        <br />
        - Tenth 2.5° belongs to the 10th sign from the D1 sign.
        <br />
        - Eleventh 2.5° belongs to the 11th sign from the D1 sign.
        <br />- Twelfth 2.5° belongs to the 12th sign from the D1 sign.
      </Typography>

      <Typography variant="body1" paragraph>
        This method programmatically reproduces the manual calculation and can
        be easily adjusted for different planets, degrees, and signs.
      </Typography>
    </>
  );

  return <SimplePaper title={title} body={body} />;
};

export default D12fromD1;
